export const driveBase = '';

export const errorMessages = {
  E_INVALID_AUTH_PASSWORD: 'Senha inválida',
  E_INVALID_AUTH_UID: 'Usuário não encontrado',
  E_INVALID_CREDENTIAL: 'Senha inválida',
  ER_DUP_ENTRY: 'Cadastro duplicado',
  E_ROW_NOT_FOUND: 'Cadastro não encontrado',
  E_DUP_GESTAO_FOUND: 'Mais de uma gestão encontrada para o domínio'
};
